<template>
    <BasePanel
        :headline="panelDetails[0]['title']"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-description'">
                        {{ $t(panelDetails[0]['description']) }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :headers="headers"
                            :items="panelDetails"
                            hide-default-footer
                            class="noMinWidth"
                            :header-props="{ sortIcon: '' }"
                        >
                            <!-- Headers -->
                            <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                            </template>

                            <!-- Items -->
                            <template v-slot:[`item.status`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-status'">
                                    <v-checkbox
                                        class="mt-0"
                                        v-model="item.status"
                                        hide-details
                                        @change="openChangeStatusDialogFunction(item)"
                                        :disabled="getDisabledStatus(item.disabled)"
                                    >
                                        <template v-slot:label>
                                            <span 
                                                style="font-size: 0.875rem !important;"
                                                class="black--text" 
                                                :alvqa="alvqa + '-text'"
                                            >
                                                {{ 
                                                    item.status === 0 || item.status === false ? 
                                                    $t('lang_ACCOUNT_MODULES_CHECKBOX_CAPTION_ACTIVATE_NOW') 
                                                    : $t('lang_ACCOUNT_MODULES_CHECKBOX_CAPTION_BOOKED')
                                                }}
                                            </span>
                                        </template>
                                    </v-checkbox>
                                </div>
                            </template>
                            <template v-slot:[`item.price`]="{ item }">
                                <v-select 
                                    v-model="item.selectedStorageOption"
                                    :items="getStorageOptions(item.storageOptionDb)" 
                                    menu-props="offset-y"
                                    class="text-right"
                                >
                                    <template v-slot:item="{ item }">
                                        <span :alvqa="alvqa + '-price-dropdown-' + item.value">
                                            {{ item.text }}
                                        </span>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        <span
                                            
                                            :alvqa="alvqa + '-price-dropdown-' + item.value"
                                        >
                                            {{ item.text }}
                                        </span>
                                    </template>
                                </v-select>
                            </template>
                            <template v-slot:[`item.patronage`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-patronage'">
                                    {{ $t(item.patronage) }}
                                </div>
                            </template>
                            <template v-slot:[`item.paymentCycle`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-payment-cycle'">
                                    {{ $t(item.paymentCycle) }}
                                </div>
                            </template>
                            <template v-slot:[`item.bookedOn`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-payment-booked-on'">
                                    {{ item.bookedOn === null ? item.bookedOn : $d(new Date(item.bookedOn), 'alvDateFormat') }} 
                                </div>
                            </template>
                            <template v-slot:[`item.minimumPeriod`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-minimum-period'">
                                    {{ getMinimumPeriod(item.minimumPeriod) }}
                                    {{ item.expiresOn === null ? '' : '(' + $d(new Date(item.expiresOn), 'alvDateFormat') + ')' }}
                                </div>
                            </template>
                            <template v-slot:[`item.link`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-information'">
                                    <a :href="item.link" target="_blank">{{ $t('lang_ACCOUNT_MODULES_CAPTION_CLICK_HERE') }}</a>
                                </div>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

export default {
    name: "AlvVaultModulePanel",
    components: {
        BasePanel
    },
    props: {
        headers: Array,
        openChangeStatusDialogFunction: {
            type: Function,
            default: () => {},
        }
    },
    data() {
        return {
            alvqa: "account-modules-alv-vault-panel"
        }
    },
    computed: {
        panelDetails() { return [this.$store.getters.getAlvVaultModulePanelDetails] }
    },
    methods: {
        getDisabledStatus(disabled) {
            return disabled === null ? false : true
        },
        getMinimumPeriod(minimumPeriod) {
            let splitArr = minimumPeriod.split(' ')
            let str = splitArr[0] + ' ' + this.$t(splitArr[1])
            return str
        },
        getStorageOptions(storageOptionDb) {
            let items = []

            for(let [key, element] of Object.entries(storageOptionDb)) {
                let text = this.$t('lang_MODULES_STORAGE_OPTION').replace(/<storage_limit>|<price>/gi, matched => {
                    return {
                        '<storage_limit>': element.storage_limit,
                        '<price>': this.$n(element.price, 'number')
                    }[matched]
                })

                let item = {
                    'value': element.id,
                    'text': text
                }
                 
                items.push(item)
            }

            return items
        }
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>